<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <van-list
    v-model:loading="loading"
    :finished="end"
    finished-text="没有更多了"
    @load="getList()"
  >
    sdfsdf
  </van-list>
</template>

<script>
export default {
  data(){
    return {
      loading:false
    }
  },
  watch:{
  },
  methods:{
    getList(page=1){
      this.loading = false;
      console.log(page)
    },
    apply(){
      this.showDialog({
        showCancelButton:true,
        cancelButtonText:"退出申请",
        confirmButtonText:"重新选择",
        message: '抱歉！您的观点不符合本网站经营理念\n感谢您的参与!',
      }).then(() => {
        console.log("正确")
      }).catch(()=>{
        console.log("错误")
      });
    },
    next(){
      console.log("下一步")
    }
  },
  created(){
  }
}
</script>

<style>
</style>
